import templateUrl from 'emun.shopping.admin/dashboard-customer-note.html'
class DashboardCustomerNoteController {
    constructor($rootScope, $state,$stateParams, createAutoQuery, $window, $session, createServiceBus) { 
        this.bus = createServiceBus($rootScope);
        this.$state = $state;
        this.retailerQuery = createAutoQuery({
            url: 'QueryRetailers.json?Id=' + this.customerId,
            autoLoad: true,
            onLoaded: args => {
                this.note.companyName = args.first.companyName;
                this.note.retailerId = args.first.id;
            }
        });
        this.note = {
            createdBy: $session.userAuthName,
            createdOn: new Date(),
            note: ""
        };
    }
    goBack() {
        let $ctrl = this;
        if ($ctrl.callback == "customer-list") {
            $ctrl.$state.transitionTo('customer-list');
        } else if ($ctrl.callback == "customer") {
            $ctrl.$state.transitionTo('customer-dashboard', {customerId: $ctrl.customerId});
        }
    }
    save() {
        let $ctrl = this;
        if($ctrl.note.id) {
            $ctrl.bus.send('UpdateRetailerNote.json', $ctrl.note).then(function (response) {
            });
        } else {
            $ctrl.bus.send('CreateRetailerNote.json', $ctrl.note).then(function (response) {
                $ctrl.goBack();
            });
        }
    }
    cancel() {
        let $ctrl = this;
        $ctrl.goBack();
    }
    toggleAlert() {
        let $ctrl = this;
        $ctrl.note.alert ? $ctrl.note.alert = false : $ctrl.note.alert = true;
    }
}

let DashboardCustomerNote = {
    bindings: {
        customerId: '@',
        noteId: '@',
        callback: '@'
    },
    controller: DashboardCustomerNoteController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

angular.module('emun.shopping.admin').component('dashboardCustomerNote', DashboardCustomerNote);

export default DashboardCustomerNote